import { createContext, useContext, useState } from 'react';

const ComponentDetailContext = createContext<{
    editModeState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
} | null>(null);

export const ComponentDetailContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isEditMode, setIsEditMode] = useState(false);

    return (
        <ComponentDetailContext.Provider value={{ editModeState: [isEditMode, setIsEditMode] }}>
            {children}
        </ComponentDetailContext.Provider>
    );
};

export const useComponentDetailContext = () => {
    const context = useContext(ComponentDetailContext);
    if (!context) throw new Error('useComponentDetailContext must be used within a provider');
    return context;
};
